import {Injectable} from "@angular/core";

export enum ComponentType {
  PAGE,
  PREFAB,
  PARTIAL,
  WIDGET
}

@Injectable()
export abstract class ComponentRefProvider {
  abstract getComponentFactoryRef(componentName: string, componentType: ComponentType, options?: any): Promise<any>;
  clearComponentFactoryRefCache(): void {};
  abstract updateFragmentResources(content: any, componentName: string, componentType: ComponentType): void;
}

export abstract class PrefabConfigProvider {
  abstract getConfig(prefabName: string): Promise<any>;
}
